<template>
  <div class="container smart-buy">
    <div class="flex-row first">
      <div class="column">
        <div class="heading">
          <h2>The Smart Way to<br> Buy a Car.</h2>
          <p>Take control of your car shopping experience. Get pre-approved for a car loan and find your perfect vehicle all from the comfort of your own home in under 3 minutes. </p>
        </div>
      </div>
      <div class="column">
        <img
          :src="require('@/assets/img/landing-page/smart-buy-car/suv.png')"
          alt="Canada Drives has thousands of cars you can qualify for."
        >
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SmartBuyCar'
}
</script>

<style lang="scss" scoped>
  a {
    cursor: pointer;
  }
  img {
    max-width: 100%;
  }
  .container.smart-buy {
    margin-top: -40px;
  }

  .heading {
    text-align: center;
    margin-bottom: 50px;
    @include breakpoint('desktop-up') {
      margin-bottom: 70px;
    }
    h2 {
      @include breakpoint('tablet-portrait-up') {
        font-size: 36px;
        text-align: left;
      }
      @include breakpoint('desktop-up') {
        font-size: 50px;
        margin-left: auto;
        margin-right: auto;
        line-height: 60px;
      }
    }
    p {
      @include breakpoint('tablet-portrait-up') {
        max-width: 630px;
        margin-left: auto;
        margin-right: auto;
        text-align: left;
      }
      @include breakpoint('desktop-up') {
        max-width: 670px;
      }
    }
  }
  .flex-row {
    margin-bottom: 35px;
    @include breakpoint('mobile-only') {
      text-align: center;
    }
    @include breakpoint('tablet-portrait-up') {
      align-items: center;
      justify-content: center;
      display: flex;
    }
    @include breakpoint('desktop-up') {
      margin-bottom: 70px;
    }
    &.first {
      @include breakpoint('tablet-portrait-up') {
        .column:last-child {
          padding-left: 50px;
        }
      }
      @include breakpoint('tablet-portrait-up') {
        .column:last-child {
          padding-right: 30px;
        }
        .column:last-child {
          padding-left: 0px;
        }
      }
      @include breakpoint('tablet-portrait-up') {
        .column:last-child {
          padding-right: 50px;
        }
        flex-direction: row-reverse;
      }
    }
  }
  .column {
    @include breakpoint('tablet-portrait-up') {
      flex: 50%;
      &.second {
        padding-left: 50px;
      }
    }
  }
</style>
